import { api } from '../index';

export const getValue = () => api.get('/collection-matrix/lrf');
